import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the benign "ResizeObserver loop completed with undelivered
// notifications" warning that the Ecwid product widget triggers. The CRA
// dev-server overlay would otherwise surface it as a red runtime error.
const RESIZE_OBSERVER_ERR = "ResizeObserver loop";
window.addEventListener(
  "error",
  (e) => {
    if (e.message && e.message.includes(RESIZE_OBSERVER_ERR)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);
window.addEventListener(
  "unhandledrejection",
  (e) => {
    if (e.reason && String(e.reason).includes(RESIZE_OBSERVER_ERR)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
